import { getOr, map, reduce, includes, isUndefined, isObject } from 'lodash/fp';

const reduceWithKey = reduce.convert({ cap: false });

export default result => {
  const SUMMABLE_COLUMNS = ['household_total'];
  const isSumableColumn = includes(SUMMABLE_COLUMNS);
  const formattedResult = map(
    reduceWithKey((newItem, each, column) => {
      if (isObject(each)) {
        const { value, groupBy } = each;
        const groupByProp = groupBy ? { [`${column}_group`]: groupBy } : {};
        const valueProp = () => {
          if (isUndefined(value)) return {};
          const suffix = isSumableColumn(column) ? 'sum' : 'count';
          const key = groupBy ? `${column}_${suffix}` : column;
          return { [key]: value };
        };
        return { ...newItem, ...groupByProp, ...valueProp() };
      }
      return { ...newItem, [column]: each };
    }, {})
  )(getOr({}, 'items', result));

  return formattedResult;
};
